import { Injectable } from '@angular/core';
import { ManagerModel } from 'src/app/core/models/manager.model';

@Injectable({
  providedIn: 'root'
})
export class ManagerMenuService {

  constructor() { }

  private items: ManagerModel[] = [
    {
      name: 'Início',
      icoName: 'home',
      route: '/manager-inicio'
    },
    {
      name: 'Suas informações',
      icoName: 'person',
      route: '/manager-user-info'
    },
    {
      name: 'Lista de presentes',
      icoName: 'view_module',
      route: '/manager-lista'
    }
  ];

  public getMenuList() {
    return this.items;
  }
}
